module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-stone-path.2bc365e3.png";